import { render, staticRenderFns } from "./TablaCatequistas.vue?vue&type=template&id=303cfe6a&scoped=true&"
import script from "./TablaCatequistas.vue?vue&type=script&lang=js&"
export * from "./TablaCatequistas.vue?vue&type=script&lang=js&"
import style0 from "./TablaCatequistas.vue?vue&type=style&index=0&id=303cfe6a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303cfe6a",
  null
  
)

export default component.exports